import React, { Component } from "react";

import "./PageBanner.scss";

export default class PageBanner extends Component {
  render() {
    const { bannerImg, title } = this.props;
    // topTitle, text
    return (
      <section className="page-banner mb-0">
        <div className="container">
          <div className="col-12">
            <div className="title-wrap">
              {/* <h5 className="top-text">{topTitle}</h5> */}
              <h1>{title}</h1>
              {/* <p>{text}</p> */}
            </div>
          </div>
          <div
            className="bg-block"
            style={{ backgroundImage: `url(${bannerImg})` }}
          />
        </div>
      </section>
    );
  }
}
